import type { ReactElement } from 'react';
import { useModalDialog } from '@/shared/lib';
import { Button, DialogFrame } from '@/shared/ui';

interface DeleteReviewDialogProps {
  readonly onConfirm: () => void;
  readonly onClose: () => void;
  readonly pending: boolean;
  readonly message: string | null;
}

/** 후기 삭제 확인 — 모달로 띄우고, 처리 중에는 Escape 로 닫지 않는다. */
export const DeleteReviewDialog = ({
  onConfirm,
  onClose,
  pending,
  message,
}: DeleteReviewDialogProps): ReactElement => {
  const modal = useModalDialog(onClose, !pending);

  return (
    <DialogFrame
      modal={modal}
      title="후기를 삭제할까요?"
      footer={
        <>
          <Button type="button" variant="destructive" disabled={pending} onClick={onConfirm}>
            삭제
          </Button>
          <Button type="button" variant="ghost" disabled={pending} onClick={onClose}>
            취소
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <p>삭제하면 이 주문으로는 후기를 다시 쓸 수 없어요.</p>
        {message ? (
          <p role="alert" className="text-destructive">
            {message}
          </p>
        ) : null}
      </div>
    </DialogFrame>
  );
};
